(ns client-portal.client.drive-thru.locations.list.views
  (:require [client-portal.client.anonymous.data :as anon.d]
            [client-portal.client.layout :as l]
            [client-portal.client.drive-thru.locations.list.data :as list.d]
            [shared.core.components.components :as c]
            [shared.core.style :as style]
            [shared.core.reactive :as re]
            [shared.core.util :as util]
            [clojure.string :as s]))

(defn ->address-string [{:keys [city postal-code state-code street-address]}]
  (util/->formatted-address {:city city
                             :state state-code
                             :street-address-1 street-address
                             :zip postal-code}))

(defn separator-dot []
  [:span {:style {:flex "0 0 auto"
                  :margin "0 5px"}}
   "•"])

(defn drive-thru-location-label [{:keys [label mac-address]}]
  [:span {:style {:flex "0 0 auto"
                  :font-weight style/font-medium-weight}}
   (anon.d/location-label label)])

(defn drive-thru-location-address [{:keys [style] :as loc}]
  (let [address (->address-string loc)
        address? (not (s/blank? address))]
    (when address?
      [:span {:style (merge {:flex 1
                             :font-style :italic
                             :overflow :hidden
                             :text-overflow :ellipsis
                             :white-space :nowrap
                             :max-width "100%"}
                            style)}
       address])))

(defn drive-thru-location-row [{:keys [id pos-location-id mac-address brand-location-id menu cohorts timezone size]
                                :as loc}]
  (let [small? (= size :small)]
    [c/standard-tree-contents
     {:content [:div {:style (cond-> {:flex 1
                                      :display :flex
                                      :align-items :center
                                      :max-width "100%"}
                                     small? (assoc :flex-direction :column
                                                   :align-items :flex-start))}
                [:span {:style {:display :flex
                                :align-items :center
                                :line-height 1.3
                                :overflow :hidden
                                :text-overflow :ellipsis
                                :white-space :nowrap}}
                 
                 [drive-thru-location-label loc]]
                (when (and (not (s/blank? mac-address)) (not small?))
                  [separator-dot])
                mac-address
                (when (and (not (s/blank? (->address-string loc))) (not small?))
                  [separator-dot])
                [drive-thru-location-address (assoc loc :style (when small? {:margin-top 3}))]]


      :content-style {:flex 1}
      :click-to-copy-pills [(when id
                              {:label id
                               :description "ID"})
                            (when pos-location-id
                              {:label pos-location-id
                               :description "POS ID"})
                            (when brand-location-id
                              {:label brand-location-id
                               :description "Brand Location ID"})
                            (when menu
                              {:label (:label menu)
                               :description "Menu"})
                            (when (and timezone (not small?))
                              {:label timezone
                               :description "Timezone"})
                            (when (and (some-> cohorts (count) (pos?)) (not small?))
                              {:label (str (count cohorts)
                                           (util/pluralize " Cohort" (count cohorts)))
                               :description (into [:div {:style {:display :flex
                                                                 :flex-direction :column}}]
                                                  (map-indexed (fn [idx {:keys [label] :as cohort}]
                                                                 [:span {:style {:margin-top (if (= idx 0) 0 5)}}
                                                                  (str label
                                                                       " ("
                                                                       (-> cohort :type :label)
                                                                       ")")])
                                                               cohorts))})]}]))

(defn drive-thru-locations-list-root [_]
  (let [concept-id- (re/subscribe [:concepts/current-concept-id-])
        search- (re/subscribe [:form/val- list.d/root-path :search])
        cur-locations- (re/subscribe [:drive-thru/locations-by-current-concept-id-])]
    (fn [args]
      (let [lc-search (some-> @search- (s/lower-case))]
        [l/logged-in-with-header-nav (merge args
                                            {:data-loading? (when @concept-id- (util/loading? @cur-locations-))
                                             :concept-dropdown? true})
         [c/input {:container-style {:margin-bottom 10}
                   :style {:width "100%"}
                   :form-path list.d/root-path
                   :form-name :search
                   ;:size (if @mobile?- :medium :large)
                   :clearable? true
                   :placeholder "Search by Name, Novo ID, or POS ID"}]
         (if @concept-id-
           (when-not (util/loading? @cur-locations-)
             (let [filtered-locations (if (s/blank? lc-search)
                                        @cur-locations-
                                        (filter #(or (or (s/includes? (s/lower-case (:label %)) lc-search)
                                                         (let [address (util/->formatted-address {:city (:city %)
                                                                                                  :state (:state-code %)
                                                                                                  :street-address-1 (:street-address %)
                                                                                                  :zip (:postal-code %)})]
                                                           (and (some? address)
                                                                (s/includes? (s/lower-case address) lc-search))))
                                                     (#{(str (:id %))
                                                        (str (:pos-location-id %))
                                                        (str (:brand-location-id %))
                                                        (str (:mac-address %))} lc-search))
                                                @cur-locations-))]
               (if (= (count filtered-locations) 0)
                 [l/message-section "No Locations Match Your Search"]
                 [:div
                  [:div {:style {:color (style/color :gray :base)
                                 :font-size 12
                                 :font-style :italic
                                 :font-weight style/font-medium-weight
                                 :padding "3px 0 10px"
                                 :opacity 0.8}
                         :theme (style/dark-style {:color (style/dark-color :on-background :base)})}
                   (str (util/readable-number (count filtered-locations))
                        (util/pluralize " Location" (count filtered-locations))
                        " Displayed")]
                  [c/table {:rows (map (fn [loc]
                                         (let [loc (assoc loc :concept {:id @concept-id-})]
                                           {:actions []
                                            :on-click (fn [_]
                                                        (re/dispatch [:router/go [:drive-thru/location
                                                                                  {:concept-id @concept-id-
                                                                                   :location-id (:id loc)
                                                                                   :mac-address (:mac-address loc)
                                                                                   }]]))
                                            :always-show-actions? false ;mobile?
                                            :cells [[drive-thru-location-row (assoc loc :size nil #_(when mobile? :small))]]}))
                                       filtered-locations)
                            :row-height 56
                            :show-actions-toggle? false       ;mobile?
                            :virtual-scroll-container-id "with-header-nav-scroll-panel"}]])))
           [l/message-section "No Concept Selected"])]))))
